import { stringParam } from '@blockit/web-shared/router/searchCodec';
import { EveChatGate } from '@features/eveChat/EveChatGate';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/_authenticated/_shell/personal-chat')({
  validateSearch: z.object({ chat: stringParam, view: stringParam }),
  component: EveChatGate,
});
